function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.119 30l-1.061 1.06-20 20-1.06 1.061-1.061-1.06-9.998-10L21.88 40 24 37.879l1.061 1.06 8.937 8.94 18.939-18.94 1.06-1.06L56.12 30z",
  fill: "#fff"
});

var SvgRoleSelected = function SvgRoleSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01Ni4xMTg2IDMwTDU1LjA1OCAzMS4wNjA2TDM1LjA1OCA1MS4wNjA2TDMzLjk5NzEgNTIuMTIxNUwzMi45MzY1IDUxLjA2MDVMMjIuOTM5NCA0MS4wNjA1TDIxLjg3ODkgMzkuOTk5N0wyNC4wMDA1IDM3Ljg3ODZMMjUuMDYxIDM4LjkzOTVMMzMuOTk3NSA0Ny44Nzg1TDUyLjkzNjYgMjguOTM5M0w1My45OTczIDI3Ljg3ODdMNTYuMTE4NiAzMFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgRoleSelected as ReactComponent };